import React, { useState } from "react";
import { Box, Button, makeStyles } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import SwipeableViews from "react-swipeable-views";

import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@material-ui/icons/ChevronRightRounded";

const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  sliderContent: {
    margin: "0 0 1% 0",
    position: "relative",
  },
  btnL: {
    backgroundColor: palette.secondary.main,
    position: "absolute",
    zIndex: 1,
    bottom: "15% !important",
    left: "15% !important",
    padding: "0px 0px 0px 0px !important",
    display: "flex!important",
    justifyContent: " center!important",
    alignItems: " center!important",
    alignContent: "center!important",
  },
  btnR: {
    backgroundColor: palette.secondary.main,
    position: "absolute",
    zIndex: 1,
    bottom: "15%",
    right: "15%",
    padding: "0px 0px 0px 0px !important",
    display: "flex!important",
    justifyContent: " center!important",
    alignItems: " center!important",
    alignContent: "center!important",
  },
  arrows: { fontSize: "40px" },
}));

const Slider = (props) => {
  const classes = useStyles();

  let start = props.start;

  const [activeStep, setActiveStep] = useState(start ? start : 0);

  const handleNext = () => {
    activeStep < props.render.length - 1
      ? setActiveStep(activeStep + 1)
      : setActiveStep(activeStep);
  };
  const handleBack = () => {
    activeStep > 0 ? setActiveStep(activeStep - 1) : setActiveStep(activeStep);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box component="div" className={classes.sliderContent}>
      <Button onClick={handleBack} className={classes.btnL}>
        <ChevronLeftRoundedIcon className={classes.arrows} />
      </Button>
      <SwipeableViews
        index={activeStep}
        onChangeIndex={handleStepChange}
        className={classes.swiper}
      >
        {props.render.map((about) => (
          <div>{about()}</div>
        ))}
      </SwipeableViews>
      <Button onClick={handleNext} className={classes.btnR}>
        <ChevronRightRoundedIcon className={classes.arrows} />
      </Button>
    </Box>
  );
};

export default Slider;
